'use client'
import { createSlice } from '@reduxjs/toolkit'

const INITIAL_STATE = {
  count: 0,
}

const dummySlice = createSlice({
  name: 'dummySlice',
  initialState: INITIAL_STATE,
  reducers: {
    resetState: () => INITIAL_STATE,
  },
})
export const { resetState } = dummySlice.actions
dummySlice
export default dummySlice
